import UseInView from "./useInView";

const SplitText = ({ text, className="", delay:baseDelay=0 }) => {
  const [ref,vis] = UseInView();
  let ci = 0;
  return <span ref={ref} className={`inline ${className}`} aria-label={text}>{text.split(" ").map((w,wi)=>(<span key={`w-${wi}`} className="inline-block whitespace-nowrap" style={{marginRight:"0.25em"}}>{w.split("").map((ch,chIdx)=>{const i=ci++;return<span key={`c-${wi}-${chIdx}`} className="inline-block" style={{transform:vis?"translateY(0) rotateX(0)":"translateY(105%) rotateX(-80deg)",opacity:vis?1:0,transition:`all 0.85s cubic-bezier(0.16,1,0.3,1) ${baseDelay+i*0.04}s`,transformOrigin:"bottom center"}}>{ch}</span>})}</span>))}</span>;
};

export default SplitText;